import { useRef, useState } from 'react';
import { Account, PartnerAccountsRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

// The accounts `/partner/account` lists for the partner account the host's api signs as (ID-14075): every
// account under it, sub-accounts included — the set `/partner/account/transactions` answers for, which is
// what the Transaction History's Account filter picks from. Logs once and rethrows; the caller surfaces it.
export default function useFetchPartnerAccounts() {
  const api = useApi();
  const [fetchingPartnerAccounts, setFetchingPartnerAccounts] = useState(false);
  const [partnerAccounts, setPartnerAccounts] = useState<Account[]>([]);

  // Only the newest request may write the state: the picker refetches per search and nothing cancels the
  // request in flight, so a slower earlier answer would otherwise replace the results for what was typed.
  const latestRequestID = useRef(0);

  async function fetchPartnerAccounts(params: PartnerAccountsRequest) {
    latestRequestID.current += 1;
    const requestID = latestRequestID.current;
    const isLatest = () => latestRequestID.current === requestID;

    try {
      setFetchingPartnerAccounts(true);

      const res = await api.fetchPartnerAccounts(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      // Absent only on a CSV export, which this listing never asks for.
      if (isLatest()) setPartnerAccounts(res.Accounts ?? []);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      if (isLatest()) setFetchingPartnerAccounts(false);
    }
  }

  return { fetchingPartnerAccounts, partnerAccounts, fetchPartnerAccounts };
}
